import { useState } from "react";

import useMount from '../../hooks/useMount';
import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import processApi from "../../api/processApi";
import ProcessDesigner from "./ProcessDesigner";

import { getLabel, getLanguage } from "../../tools/Dictionary";

const ProcessDesignerCopyExternal = (props) =>
{

  //Props
  const IsDesktop = props.IsDesktop;
  const Process = props.Process;
  const OnCloseModal = props.OnCloseModal;
  const OnConfirm = props.OnConfirm;

  //State
  const [mode, setMode] = useState(0) //0 = Choose process, 1 = Choose steps
  const [process, setProcess] = useState([]);
  const [currentProcess, setcurrentProcess] = useState(-1);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });


  useMount(() =>
  {
    loadData();
  });


  const loadData = async (_showLoading = true, _id = 0) =>
  {

    try
    {

      if (_showLoading)
      {
        setLoading(true);
      }

      let [processData,] = await Promise.all([
        processApi.getProcesses({ select: "_id,code", translate: getLanguage().code })
      ]);

      if (processData.Success)
      {


        //let loadedProcess = applyListFilterAndSort(processData.Data, column, sort);

        setProcess(processData.Data.filter(p => p._id != Process._id));
        //checkDataUpdateForPagination(loadedProcess, pagination);


      } else
        throw new Error(processData.Error.label);


      setLoading(false);

    } catch (err)
    {

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

  };

  const onClickProcess = (_id) => {

    setcurrentProcess(_id);
    setMode(1);

  };

  const onClickContext = (e) =>
  {
    if (mode == 0) e.stopPropagation();
  };

  const onConfirmExternalCopy = (_data) => {

    OnConfirm(_data);

  }


  if (mode == 1){
    return (
      <div className="page_modal_background" onContextMenu={onClickContext}>
        <div className="page_modal_cont" style={{ width: "900px" }}>
          <ProcessDesigner
            IsDesktop={IsDesktop}
            ProcessId={currentProcess}
            Title={""}
            OnClose={() => setMode(0)}
            OnReloadData={loadData}
            IsExternalCopy={true}
            OnConfirmExternalCopy={onConfirmExternalCopy}
          />
        </div>
      </div>
    )
  }



  return (
    <div className="page_modal_background" onContextMenu={onClickContext}>
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("ProcessDesigner", "Select a process")}
        </div>
        <div className="page_modal_body_cont">
          <div className="processdesigner_external_cont">
            {process.map(p => (
              <div className="processdesigner_external_item page_noselect" key={p._id} onClick={() => onClickProcess(p._id)}>
                {p.code}
              </div>
            ))}

          </div>
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );

};

export default ProcessDesignerCopyExternal